export default __webpack_public_path__ + "static/media/404-error-page2-m.277c47e2.svg";